
import { Component, Mixins, Watch, Prop, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { getErrorMessage } from '@/utils/common';
import { mutations } from '@/store/types';
import api from '@/modules/api';

@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class JoinGroupModal extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    @Prop({ type: Function, required: true })
    refresh!: () => void;

    groupJoinCode = '';

    async save(e: Event) {
        e.preventDefault();
        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            await api.joinGroupByCode(this.groupJoinCode);
            Vue.toasted.success(`joined successfully`);
            this.groupJoinCode = '';
            this.refresh();
            this.model = false;
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) this.groupJoinCode = '';
    }
}
